<template>
  <div class="box">
    <div class="header">
      <div class="title">分润余额(元)</div>
      <div class="price">{{ this.balance }}</div>
    </div>
    <div class="content" ref="container">
      <van-notice-bar color="#ffa347" background="#ecf9ff" >
          <van-button v-if="accountList.length>0" size="small" plain @click="showWithdrawal" class="withdrawal-btn">
            <van-icon name="plus" />分润提现
          </van-button>
          <van-button size="small" plain class="withdrawal-btn bind-btn" :to="{ name: 'AgentAccount', query: { active: accountList.length>0?0:1 } }">
            <template v-if="accountList.length>0">
              <van-icon name="todo-list-o" />提现记录
            </template>
            <template v-else>
              <van-icon name="plus" />去绑定提现账户
            </template>
          </van-button>
      </van-notice-bar>
      <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''" :offset-top="offsetTop" :container="container">
        <div class="list bc">
          <h3>{{ nowTime }}</h3>
          <div class="icons">
            <van-icon name="notes-o" @click="showPicker = true" />
            <van-icon name="replay" @click="replay" />
          </div>
        </div>
      </van-sticky>
      <VANABS :list= list :paramsList=paramsList @change="changlist"></VANABS>
    </div>
    <van-popup round  v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm= "onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <!-- 绑定弹窗 -->
    <van-popup v-model="showWithdrawalPopup" position="bottom" round destroy-on-close
      :style="{ minHeight: '80vh',maxHeight: '90vh', paddingBottom: 'env(safe-area-inset-bottom)' }">
      <div class="withdrawal-popup">
        <div class="popup-nav">
          <span class="nav-title">分润提现</span>
          <span class="nav-close" @click="showWithdrawalPopup = false">关闭</span>
        </div>
      <ProfitWithdrawal :accountList="accountList" v-if="accountList.length>0" @submit="withdrawalSubmit"/>
      </div>
    </van-popup>
  </div>
</template>
<script>
import VANABS from '@/components/BalanceVanTab'
import ProfitWithdrawal from '@/components/ProfitWithdrawal'
import { profit, profitList } from '@/api/user.js'
import {
  withdrawalAccount
} from '@/api/withdrawal.js'
export default {
  components: { VANABS, ProfitWithdrawal },
  props: {},
  data () {
    return {
      accountList: [],
      showWithdrawalPopup: false,
      show: false,
      date: '',
      nowTime: '2025年6月',
      showPicker: false,
      currentDate: new Date(),
      balance: '',
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        createTime: ''
      },
      list: [],
      stickyChangeFlag: false,
      container: null,
      offsetTop: '0'
    }
  },
  watch: {},
  computed: {
    minDate: function () {
      const time = new Date().getTime()
      const minTime = (time - 1000 * 60 * 60 * 24 * 30 * 5) * 1
      return new Date(minTime)
    },
    maxDate: function () {
      return new Date()
    }
  },
  methods: {
    async getAccountList () {
      try {
        const userId = (this.$store.state.userID || '').split('a')[0]
        if (!userId) return

        const {
          data: response
        } = await withdrawalAccount({
          isValid: 1,
          token: this.$store.state.token,
          userId
        })
        this.accountList = response.extend.rows || []
      } catch (e) {
        console.error('[Account List Error]', e)
      }
    },
    // 重置时间查询
    replay () {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否重置查询时间'
      }).then(async () => {
        window.scrollTo(0, 0)
        this.paramsList.createTime = ''
        this.paramsList.page = 1
        this.nowTime = new Date().getFullYear() + '年' + (new Date().getMonth() * 1 + 1) + '月' + new Date().getDate() + '日'
        const { data: res } = await profitList(this.paramsList)
        if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login')
          this.$toast.fail('请重新登录')
        }
        // res.extend.rows.forEach(item => {
        //   item.createTime = item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0]
        // })
        this.list = res.extend.rows
        if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
          // 更新获取下一次数据的时间戳
          this.paramsList.page++
        }
        // on close
      }).catch(() => {
        this.$toast('取消重置')
      })
    },
    formatDate (date) {
      return `${date.getFullYear()}年 ${date.getMonth() + 1}月 ${date.getDate()}月`
    },
    async onConfirm (date) {
      // window.scrollTo(0, 0)
      // this.showPicker = false
      this.nowTime = this.formatDate(date)
      // this.paramsList.page = 1
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const days = year + '-' + month + '-' + day
      this.paramsList.createTime = days
      // const { data: res } = await profitList(this.paramsList)
      // // res.extend.rows.forEach(item => {
      // //   item.createTime = item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0]
      // // })
      // this.list = res.extend.rows
      // if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
      //   // 更新获取下一次数据的时间戳
      //   this.paramsList.page++
      // }
      this.reqProfitList()
    },
    async reqProfitList () {
      window.scrollTo(0, 0)
      this.showPicker = false
      this.paramsList.page = 1
      const { data: res } = await profitList(this.paramsList)
      // res.extend.rows.forEach(item => {
      //   item.createTime = item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0]
      // })
      this.list = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      }
    },
    async profit () {
      const { data: res } = await profit({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      this.balance = res.balance
    },
    changlist (e) {
      if (e.type === 'add') {
        this.list.push(...e.list)
      } else {
        this.list = []
      }
    },
    showWithdrawal (e) {
      this.showWithdrawalPopup = true
    },
    withdrawalSubmit (e) {
      this.showWithdrawalPopup = false
      this.profit()
      this.reqProfitList()
    },
    stickyChange (e) { this.stickyChangeFlag = e.isFixed }
  },
  beforeCreate () {},
  created () {
    this.profit()
    this.nowTime = new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月' + new Date().getDate() + '日'
    this.getAccountList()
  },
  mounted () {
    this.container = this.$refs.container
  }
}
</script>

<style scoped lang='less'>
  .box {
    height: 100%;
    box-sizing: border-box;
  }
  .header {
    height: 20vh;
    background-color: red;
    background: url(../../../../assets/benefit-ban-balance.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
    color: #fff;
    .title {
      font-size: 35px;
      padding-top: 60px;
      padding-bottom: 20px;
    }
    .price {
      font-size: 55px;
    }
  }
  .content {
    margin-top: -35px;
    background-color: #fff;
    border-radius: 25px;
    overflow: hidden;
    .bc {
      padding: 0 35px;
    }
    /deep/.van-notice-bar {
      width: 100vw;
    }
    /deep/.van-notice-bar__content {
      width:100%;
      display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      h3 {
        font-size: 35px;
      }
      .icons {
        width: 150px;
        display: flex;
        justify-content: space-around;
      }
    }
  }
  .bc {
    margin-bottom: 25px;
    font-size: 45px;
  }
  .stickyBottom {
    .list {
      background-color: #ffa347!important;
      color: #fff;
      height: 100px;
    }
  }

.withdrawal-btn {
  flex-shrink: 0;
  white-space: nowrap;

  /* ✅ 核心尺寸：15px文字 + 36px高度，平衡可读性与克制感 */
  height: 36px !important;
  padding: 28px 15px 28px 15px !important;
  font-size: 26px !important;
  line-height: 36px !important;
  border-radius: 15px !important;
  font-weight: 600;

  /* ✅ 业务强化：浅品牌绿底 + 品牌绿字 */
  background-color: rgba(7, 193, 96, 0.10) !important;
  color: #07C160 !important;
  border: none !important;

  /* 图标适配 */
  :deep(.van-icon) {
    margin-right: 5px;
    font-size: 22px;
    vertical-align: middle;
  }

  /* 交互反馈：温和增强，不喧宾夺主 */
  &:hover {
    background-color: rgba(7, 193, 96, 0.15) !important;
  }
}
.bind-btn {
 background-color: rgba(255, 170, 0, 0.1) !important;
  color: #aa0000 !important;
}

  .withdrawal-popup {
    padding: 15px 0 env(safe-area-inset-bottom);
  }

  .popup-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f5f7fa;
  }

  .nav-title {
    color: #c8c9cc !important;
    font-size: 26px;
    font-weight: 500;
    margin-top: -15px;
    padding-left: 15px;
  }

  .nav-close {
    margin-top: -5px;
    font-size: 26px;
    color: #c8c9cc;
    padding: 4px;
  }
</style>
